/**
 * for-brands.js
 * Shared JS for all For Brands sections.
 * Loaded once via {{ 'for-brands.js' | asset_url | script_tag }} in for-brands-hero.liquid.
 */

(function () {
  'use strict';

  function initReveal() {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    // Observe both reveal and stagger containers
    document.querySelectorAll('.fb-reveal:not(.is-visible), .fb-stagger:not(.is-visible)').forEach(function (el) {
      observer.observe(el);
    });

    window.__fbRevealObserver = observer;
  }

  function initHeroReveal() {
    var hero = document.querySelector('.fb-hero-immediate');
    if (!hero) return;
    setTimeout(function () {
      hero.querySelectorAll('.fb-reveal').forEach(function (el) {
        el.classList.add('is-visible');
      });
    }, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReveal();
      initHeroReveal();
    });
  } else {
    initReveal();
    initHeroReveal();
    setTimeout(initReveal, 300);
  }

})();
